import { ChatMessage } from '@assets/component/ChatMessage/ChatMessage';
import { ChatMessageApproveReject } from '@assets/component/ChatMessage/ChatMessageApproveReject';
import { LoadingAnimation } from '@assets/component/LoadingAnimation/LoadingAnimation';
import { ScrollPanel } from '@assets/component/Panel/ScrollPanel/ScrollPanel';
import { Flex } from '@assets/component/UI/Flex/Flex';
import { getFirebase } from '@assets/firebase/FirebaseAdapater';
import { ChatMessageData } from '@assets/model/RagAPI';
import { onValue, ref } from 'firebase/database';
import { observer } from 'mobx-react';
import { useEffect, useState } from 'react';
import * as style from './TaskChatContainer.module.less';
import { useTasksStore } from '@assets/model/Store';

interface TaskChatContainerProps {
    reportId: string;
    taskId: string;
    showWaitingAnimation: boolean;
}

export const TaskChatContainer = observer((p: TaskChatContainerProps) => {
    //use id to fetch chat
    const { reportId, taskId, showWaitingAnimation } = p;
    const [chatContent, setChatContent] = useState(null);
    const taskDef = useTasksStore().get_task_definition(taskId);
    useEffect(
        function fetchTaskContent() {
            const path = `/flowtasks/history/${reportId}/${taskId}/results`;
            const fb = getFirebase();
            const r = ref(fb.db, path);
            const unsub = onValue(r, snapshot => {
                const data = snapshot.val();
                console.log('TaskChatPanel: fetched task chat data:', data);
                setChatContent(data);
            });

            return () => {
                unsub();
            };
        },
        [taskId]
    );

    const messageData = chatContent ?? [];

    //Bit awkward to put effect after fetching data from store
    useEffect(() => {
        const chatScroll = document.getElementById('chat-scroll');
        if (chatScroll) {
            setTimeout(() => {
                chatScroll.scrollTop = chatScroll.scrollHeight;
            }, 50);
        }
    }, [messageData.length, showWaitingAnimation]);

    const handleApprove = (didApprove: boolean) => {
        var text = '';
        if (!didApprove) {
            text = prompt('Please provide a reason for rejection:', 'Reject');
        }
        if (text == '' || text == null) {
            text = '-';
        }

        const fb = getFirebase();
        fb.flowtask_add_prompt_job(reportId, taskId, {
            content: text,
            approve: didApprove
        });
    };
    const messages = [];

    type MessageType = {
        role: string;
        content: string;
        fileUploads?: any[];
        action?: any;
        state?: string;
    };
    const msgHistory: MessageType[] = messageData.map(msg => {
        return {
            role: msg.role,
            content: msg.content,
            fileUploads: msg.fileUploads || [],
            action: msg.action || null,
            state: msg.state || null
        };
    });
    msgHistory.forEach((msg, index) => {
        const msgId = 'msg_' + index;
        const isUserMessage = msg['role'] == 'userMessage';
        //const msg: any = messageData[msgId];
        if (isUserMessage) {
            const questionText: string = msg['content'];
            const msgUser: ChatMessageData = {
                isMe: true,
                message: questionText,
                date: new Date(),
                processed: true
            };
            messages.push(
                <ChatMessage msg={msgUser} key={msgId} msgId={msgId} />
            );
        } else {
            // if (msg.status == 'STOPPED') {
            //     //add a YES\NO button
            //     messages.push(
            //         <ChatMessageApproveReject
            //             onApprove={didApprove => {
            //                 handleApprove(didApprove);
            //             }}
            //             msgId={msgId}
            //             key={msgId + '_approve_reject'}
            //         />
            //     );
            // } else {
            const msgResponse: ChatMessageData = {
                isMe: false,
                message: msg['content'],
                date: new Date(),
                processed: true
            };
            messages.push(
                <ChatMessage
                    msg={msgResponse}
                    key={msgId + '_server'}
                    msgId={msgId}
                />
            );
        }
    });

    const lastMessage = msgHistory[msgHistory.length - 1] || null;

    if (lastMessage?.action != null) {
        messages.push(
            <ChatMessageApproveReject
                onApprove={didApprove => {
                    handleApprove(didApprove);
                }}
                key={'appprove_reject_id'}
            />
        );
    }

    if (messages.length === 0) {
        const msg_starting_text: ChatMessageData = {
            isMe: false,
            message: taskDef.starting_text,
            date: new Date(),
            processed: true
        };
        messages.push(
            <ChatMessage
                msg={msg_starting_text}
                key="start_message"
                msgId="start_message"
            />
        );
    }
    if (showWaitingAnimation) {
        messages.push(
            <div className="fade-in" key="animation">
                <LoadingAnimation width={200} height={100} />
            </div>
        );
    }

    return (
        <>
            <ScrollPanel
                onLoadScrollToEnd={true}
                id="chat-scroll"
                className={style.scrollFadeContent}
            >
                <Flex direction="column" justify="end">
                    {messages}
                </Flex>
            </ScrollPanel>
        </>
    );
});
